module.exports = __webpack_public_path__ + "img/HZGB12-10w.2a226af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB12-10w.png
// module id = vbJZ
// module chunks = 0